<template>
  <hypto-popup :title="'User Status'">
    <template v-slot:body>
      <p>Are you sure you want to <b>{{statusOptions.status}}</b> the user?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="toggleStatus">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/users'
import { openPopup } from '@/utils/helpers'

export default {
  name: 'ToggleStatusConfirmation',
  components: { HyptoPopup },
  props: {
    statusOptions: Object
  },
  methods: {
    openPopup,
    toggleStatus () {
      this.statusOptions.status === 'ACTIVATE' ? this.activateUser() : this.deActivateUser()
    },
    activateUser () {
      ApiServices.activateUser(this.statusOptions.id).then(response => {
        this.handleResponse(response)
      })
    },
    deActivateUser () {
      ApiServices.deActivateUser(this.statusOptions.id).then(response => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.success) {
        this.successToastMsg(response.message)
        this.openPopup(null)
        this.$emit('updateStatus', response.data.status === 'ACTIVE')
      } else {
        this.errorToastMsg(response.message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
  }

  .mobile {
    text-align: left;
  }
</style>
